import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { ShowcaseItem } from "@/lib/user-types";
import { Eye } from "lucide-react";

interface ShowcaseCardProps {
  item: ShowcaseItem;
}

export function ShowcaseCard({ item }: ShowcaseCardProps) {
  return (
    <Card className="flex flex-col rounded-lg shadow-lg overflow-hidden h-full">
      <div className="flex-shrink-0 relative group">
        <img
          className="h-48 w-full object-cover transition-transform duration-300 group-hover:scale-105"
          src={item.posterImageUrl}
          alt={item.title}
        />
        <div className="absolute inset-0 bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <Eye className="text-white h-8 w-8" />
        </div>
      </div>
      <CardContent className="flex-1 bg-white p-6 flex flex-col justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-primary-600">{item.style}</p>
          <a href="#" className="block mt-2">
            <p className="text-xl font-semibold text-gray-900">{item.title}</p>
            <p className="mt-3 text-base text-gray-500 line-clamp-3">{item.description}</p>
          </a>
        </div>
        <div className="mt-6 flex items-center">
          <Avatar className="h-10 w-10">
            <AvatarImage src={item.creator.avatarUrl} alt={item.creator.name} />
            <AvatarFallback>{item.creator.name.charAt(0)}</AvatarFallback>
          </Avatar>
          <div className="ml-3">
            <p className="text-sm font-medium text-gray-900">{item.creator.name}</p>
            <div className="flex space-x-1 text-sm text-gray-500">
              <span>{item.creator.date}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
